import __vue_normalize__ from 'vue-runtime-helpers/dist/normalize-component.mjs';
import HseSpinner from './HseSpinner.vue_rollup-plugin-vue=script.js';

/* script */
const __vue_script__ = HseSpinner;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hse-Spinner",class:{
    'hse-Spinner_loading': !_vm.done && _vm.isLoading,
    'hse-Spinner_done': _vm.done
  },style:({
    height: (_vm.sizePx + "px"),
    width: (_vm.sizePx + "px"),
    'min-width': (_vm.sizePx + "px"),
    padding: 0
  }),attrs:{"aria-valuemin":"0","aria-valuemax":"100","aria-valuenow":_vm.isLoading ? undefined : _vm.normalizedValue,"role":"progressbar"},on:{"click":function($event){_vm.cancelable && _vm.$emit('cancel', $event);}}},[(_vm.cancelable)?_c('HseClickableIcon',{staticClass:"hse-Spinner__cancel",class:_vm.classes.cancelIcon,style:({ 'z-index': _vm.done ? -1 : 1, opacity: _vm.done ? 0 : 1 }),attrs:{"icon":_vm.IconActionDelete,"size":_vm.iconSize}}):_vm._e(),_vm._v(" "),_c('svg',{staticClass:"hse-Spinner__checkmark",class:_vm.classes.checkmark,attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":(_vm.viewBoxSize + " " + _vm.viewBoxSize + " " + (2 * _vm.viewBoxSize) + " " + (2 * _vm.viewBoxSize))}},[_c('circle',{staticClass:"hse-Spinner__overlay",attrs:{"cx":2 * _vm.viewBoxSize,"cy":2 * _vm.viewBoxSize,"r":_vm.radius,"stroke-dasharray":_vm.strokeDashArray,"stroke-dashoffset":_vm.strokeDashOffset,"stroke-width":_vm.strokeWidth,"fill":"transparent"}}),_vm._v(" "),(_vm.done)?_c('path',{staticClass:"hse-Spinner__checkmark-check",style:(_vm.checkmarkCheckStyle),attrs:{"d":"M14.1 27.2l7.1 7.2 16.7-16.8","fill":"none"}}):_vm._e()])],1)};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__;
